import React, { useState, useEffect } from 'react';
import LegalService from './Service';
import './Components/LegalContent.css';

const TermsAndConditions = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        setError(null);
        setLoading(true);

        const response = await LegalService.getTermsAndConditions();

        setContent(
          response?.data?.content ||
          response?.data?.data ||
          response?.content ||
          response?.body?.content ||
          'Content not available'
        );
        setLoading(false);
      } catch (err) {
        console.error('Error fetching terms content:', err);
        setError('Failed to load content. Please try again later.');
        setLoading(false);
        setContent('Content not available at the moment.');
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, []);

  return (
    <div className="legal-content-container-public">
      <div className="legal-content-header">
        <h1>Terms and Conditions</h1>
      </div>

      <div className="legal-content-body">
        {loading ? (
          <div className="loader-container">
            <div className="spinner"></div>
            <p>Loading content...</p>
          </div>
        ) : error ? (
          <div className="error-message">
            <p>{error}</p>
          </div>
        ) : (
          <div className="legal-content-text">
            {content ? (
              <div dangerouslySetInnerHTML={{ __html: content.content}} />
            ) : (
              <p>No content available.</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TermsAndConditions;
